export const handleItemWiseSaleLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch, index, componentType) => {
    if (obj) {
        const { ledgerName, gstinNo, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('item_wise_sale_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('item_wise_sale_ledger_cd', "")
    }
}
export const handleItemWiseSaleLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch, index, componentType) => {
    if (!e.target.value) {
        setFieldValue('item_wise_sale_ledger_cd', "")
    }
}

export const handleItemWisePurchaseLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch, index, componentType) => {
    if (obj) {
        const { ledgerName, gstinNo, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('item_wise_purchase_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('item_wise_purchase_ledger_cd', "")
    }
}
export const handleItemWisePurchaseLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch, index, componentType) => {
    if (!e.target.value) {
        setFieldValue('item_wise_purchase_ledger_cd', "")
    }
}

export const handleItemWiseSTOLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch, index, componentType) => {
    if (obj) {
        const { ledgerName, gstinNo, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('item_wise_sto_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('item_wise_sto_ledger_cd', "")
    }
}
export const handleItemWiseSTOLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch, index, componentType) => {
    if (!e.target.value) {
        setFieldValue('item_wise_sto_ledger_cd', "")
    }
}

export const handleItemWiseSTILedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch, index, componentType) => {
    if (obj) {
        const { ledgerName, gstinNo, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('item_wise_sti_ledger_cd', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('item_wise_sti_ledger_cd', "")
    }
}
export const handleItemWiseSTILedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch, index, componentType) => {
    if (!e.target.value) {
        setFieldValue('item_wise_sti_ledger_cd', "")
    }
}

export const handleRlbItemNameSelection = (e, values, setFieldValue, fieldName, obj, dispatch, index, componentType) => {
    if (obj) {
        // Extract values from the selected item object
        const {
            item_name,
            item_code,
            item_group_name: item_group,
            unit_name: uom
        } = obj;

        // Set the corresponding fields in the form
        setFieldValue('rlb_item_name', item_name || '');
        setFieldValue('rlb_item_code', item_code || '');
        setFieldValue('rlb_item_group', item_group || '');
        setFieldValue('uom', uom || '');
    } else {
        // Clear the fields if no item is selected
        setFieldValue('rlb_item_name', '');
        setFieldValue('rlb_item_code', '');
        setFieldValue('rlb_item_group', '');
        setFieldValue('uom', '');
    }
}

export const handleRlbItemNameOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch, index, componentType) => {
    if (!e.target.value) {
        setFieldValue('rlb_item_code', '');
        setFieldValue('rlb_item_group', '');
        setFieldValue('uom', '');
    }
}
